import { NoticeTypes } from '@genial/components';
import { Utils } from '@genial/utils';

export const fixedIncomeQuotationNotice = {
  testId: 'fixedIncomeQuotationNotice',
  backgroundColor: Utils.ColorToken.WithOpacity('feedback.attention.lightest', 'opacity.medium'),
  type: 'warning',
  textObjects: [
    { text: 'Este ativo está disponível somente para ', variant: 'regular' },
    { text: 'COTAÇÃO', variant: 'bold' },
    { text: ', depois de realizada, esta operação não pode ser cancelada. ', variant: 'regular' },
  ] as NoticeTypes.Props['textObjects'],
} as const;
